module.exports = __webpack_public_path__ + "static/media/emmy.a021435e.jpeg";